import {axiosUtil} from "../../../utils/axios_util";

const userPermissionApi = {
    //用户组分页查询
    getUserPermissionPage(data:powerSearchData) {
        return axiosUtil({
            url: '/user_permission/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //获取某一分组指定资源类型的权限关系列表
    getSubjectResource(data:any) {
        return axiosUtil({
            url: `/user_permission/get_management_resource_relation`,
            method: 'post',
            data,
        })
    },
    //设置主体资源关系
    setSubjectResource(data:any) {
        return axiosUtil({
            url: `/user_permission/set_subject_resource_relation`,
            method: 'post',
            data,
        })
    },
    //获取页面操作权限
    getPagePermission(data:any) {
        return axiosUtil({
            url: '/base/get_page_permission',
            method: 'post',
            data,
            params: {
                managementResource: data,
            }
        })
    },
}

export default userPermissionApi
